import React from 'react';

export default function PageHeader({ icon: IconComp, title, subtitle, color, actions }) {
  return (
    <div className="page-header" style={{ background: color.bg }}>
      <div className="page-header-left">
        <div className="page-header-icon" style={{ color: color.fg }}>
          <IconComp />
        </div>
        <div>
          <h1 className="page-header-title">{title}</h1>
          {subtitle && <div className="page-header-sub">{subtitle}</div>}
        </div>
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
}
